import type { Holiday, OpeningHours } from 'lib-shared-types-api';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';

import { defaultTime, getDateAsUTC } from 'utils/date';

/**
 * Gets a list of exceptions transformed from the holiday API endpoint response
 *
 * @param params { agentName, isClosed, holidays }
 */
export function getExceptionsFromHolidays({
  agentName,
  isClosed,
  holidays,
}: {
  agentName: string;
  isClosed: boolean;
  holidays?: readonly Holiday[];
}): OpeningHours[] {
  return holidays?.length
    ? holidays.map<OpeningHours>(({ id, name, observed_date }) => {
        const startDate = getDateAsUTC(
          moment(observed_date, 'YYYY-MM-DD'),
        ).toISOString();

        return {
          created_at: moment().toISOString(),
          created_by: agentName,
          duration: 1,
          id: uuid(),
          intervals: isClosed ? [] : [{ ...defaultTime }],
          name,
          next_date: startDate,
          opening_hour_type: 'holiday',
          recurring: {
            holiday: id,
          },
          start_date: startDate,
        };
      })
    : [];
}
